import { render, staticRenderFns } from "./AttachmentSetting.vue?vue&type=template&id=9f61b41a&"
import script from "./AttachmentSetting.vue?vue&type=script&lang=js&"
export * from "./AttachmentSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports